import api from './api';

const unwrap = (res, fallback) => {
  if (res && res.success === true) return { success: true, data: res.data };
  return { success: false, error: (res && (res.message || res.error)) || fallback };
};

class EmailCampaignService {
  async listCampaigns(params = {}) {
    try {
      const res = await api.get('/admin/email-campaigns', params);
      return unwrap(res, 'Failed to list campaigns');
    } catch (e) {
      return { success: false, error: e.message || 'Failed to list campaigns' };
    }
  }

  async getCampaign(id) {
    try {
      const res = await api.get(`/admin/email-campaigns/${id}`);
      return unwrap(res, 'Failed to fetch campaign');
    } catch (e) {
      return { success: false, error: e.message || 'Failed to fetch campaign' };
    }
  }

  async createCampaign(payload) {
    try {
      const res = await api.post('/admin/email-campaigns', payload);
      return unwrap(res, 'Failed to create campaign');
    } catch (e) {
      return { success: false, error: e.message || 'Failed to create campaign' };
    }
  }

  async updateCampaign(id, payload) {
    try {
      const res = await api.put(`/admin/email-campaigns/${id}`, payload);
      return unwrap(res, 'Failed to update campaign');
    } catch (e) {
      return { success: false, error: e.message || 'Failed to update campaign' };
    }
  }

  async deleteCampaign(id) {
    try {
      const res = await api.delete(`/admin/email-campaigns/${id}`);
      return unwrap(res, 'Failed to delete campaign');
    } catch (e) {
      return { success: false, error: e.message || 'Failed to delete campaign' };
    }
  }

  async getRecipients(id, params = {}) {
    try {
      const res = await api.get(`/admin/email-campaigns/${id}/recipients`, params);
      return unwrap(res, 'Failed to fetch recipients');
    } catch (e) {
      return { success: false, error: e.message || 'Failed to fetch recipients' };
    }
  }

  async addRecipients(id, recipients) {
    try {
      const res = await api.post(`/admin/email-campaigns/${id}/recipients`, { recipients });
      return unwrap(res, 'Failed to add recipients');
    } catch (e) {
      return { success: false, error: e.message || 'Failed to add recipients' };
    }
  }

  async sendCampaign(id) {
    try {
      const res = await api.post(`/admin/email-campaigns/${id}/send`);
      return unwrap(res, 'Failed to send campaign');
    } catch (e) {
      return { success: false, error: e.message || 'Failed to send campaign' };
    }
  }

  async sendTestEmail(id, testEmail, sampleVariables = {}) {
    try {
      const res = await api.post(`/admin/email-campaigns/${id}/test`, { testEmail, sampleVariables });
      return unwrap(res, 'Failed to send test email');
    } catch (e) {
      return { success: false, error: e.message || 'Failed to send test email' };
    }
  }

  async getAnalytics(id) {
    try {
      const res = await api.get(`/admin/email-campaigns/${id}/analytics`);
      return unwrap(res, 'Failed to fetch analytics');
    } catch (e) {
      return { success: false, error: e.message || 'Failed to fetch analytics' };
    }
  }

  async getVerifiedSenders() {
    try {
      const res = await api.get('/admin/email-campaigns/verified-senders');
      return unwrap(res, 'Failed to fetch verified senders');
    } catch (e) {
      return { success: false, error: e.message || 'Failed to fetch verified senders' };
    }
  }
}

export default new EmailCampaignService();
